import { MatDialogConfig } from '@angular/material/dialog';

const XX_SMALL = '300px';
const X_SMALL = '400px';
const SMALL = '600px';
const MEDIUM = '800px';
const LARGE = '1000px';
const X_LARGE = '1200px';
const XX_LARGE = '1500px';

export const DialogConfig = {
  DEFAULT_CONFIRM_VALUE: 'PERMANENTLY DELETE',
  Size: {
    XX_SMALL,
    X_SMALL,
    SMALL,
    MEDIUM,
    LARGE,
    X_LARGE,
    XX_LARGE,
  },
  /** @deprecated Use {@link DialogConfig.Size} instead. */
  sizes: {
    /** @deprecated Use {@link DialogConfig.Size.X_SMALL} instead.
     */ small: '400px',
    /** @deprecated Use {@link DialogConfig.Size.SMALL} instead.
     */ medium: '600px',
    /** @deprecated Use {@link DialogConfig.Size.MEDIUM} instead.
     */ large: '800px',
    /** @deprecated Use {@link DialogConfig.Size.LARGE} instead.
     */ 'extra-large': '1000px',
    /** @deprecated Use {@link DialogConfig.Size.X_LARGE} instead.
     */ 'xx-large': '1200px',
    /** @deprecated Use {@link DialogConfig.Size.X_LARGE} or {@link DialogConfig.Size.XX_LARGE} instead.
     */ 'xxx-large': '1400px',
  },

  // Spreadable Configs
  XX_SMALL: { width: XX_SMALL } as MatDialogConfig,
  X_SMALL: { width: X_SMALL } as MatDialogConfig,
  SMALL: { width: SMALL } as MatDialogConfig,
  MEDIUM: { width: MEDIUM } as MatDialogConfig,
  LARGE: { width: LARGE } as MatDialogConfig,
  X_LARGE: { width: X_LARGE } as MatDialogConfig,
  XX_LARGE: {
    width: XX_LARGE,
    maxWidth: '87vw', // default is 80vw
  } as MatDialogConfig,
} as const;
